import { roundOre } from './money.js';
const MONTHS_PER = {
    monthly: 1,
    quarterly: 3,
    annual: 12,
    custom: 1,
};
/** Monthly-equivalent of an amount at a given cadence (e.g. 1.500 kr/quarter → 500 kr/mo). */
export function monthlyEquivalent(amount, cadence) {
    return roundOre(amount / MONTHS_PER[cadence]);
}
/** Annual-equivalent of an amount at a given cadence. */
export function annualEquivalent(amount, cadence) {
    return roundOre(monthlyEquivalent(amount, cadence) * 12);
}
/** Summarise a budget into the monthly figures every other module keys off. */
export function summarizeBudget(incomes, expenses) {
    const incomeMonthly = incomes.reduce((s, i) => s + monthlyEquivalent(i.amount, i.cadence), 0);
    let expenseMonthly = 0;
    let investmentMonthly = 0;
    for (const e of expenses) {
        const m = monthlyEquivalent(e.amount, e.cadence);
        expenseMonthly += m;
        if (e.isInvestmentContribution)
            investmentMonthly += m;
    }
    const consumptiveMonthly = expenseMonthly - investmentMonthly;
    return {
        incomeMonthly,
        expenseMonthly,
        investmentMonthly,
        consumptiveMonthly,
        cashNet: incomeMonthly - expenseMonthly,
        netWorthBaseline: incomeMonthly - consumptiveMonthly,
    };
}
//# sourceMappingURL=budget.js.map